import { render, staticRenderFns } from "./SessionRecapView.vue?vue&type=template&id=2095806a&scoped=true&"
import script from "./SessionRecapView.vue?vue&type=script&lang=js&"
export * from "./SessionRecapView.vue?vue&type=script&lang=js&"
import style0 from "./SessionRecapView.vue?vue&type=style&index=0&id=2095806a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095806a",
  null
  
)

export default component.exports